import type {
  AudioComponentData,
  ComponentData,
  ImageComponentData,
  UpdateEntityFileSelectFunc,
  UpdateEntityFileUploadFunc,
} from './../ricos-content';
import type { EditorPluginConfig, ViewerPluginConfig } from './../ricos-types';
export { AUDIO_TYPE } from './../ricos-content';

export type audioMenuDataType = {
  text: string;
  onClick: () => void;
  selected?: boolean;
  dataHook?: string;

  icon?: (props?: any) => JSX.Element;
}[];

export const audioButtonsTypes = { audio: 'audio', soundCloud: 'soundCloud', spotify: 'spotify' };

export interface AudioPluginEditorConfig extends EditorPluginConfig {
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
  fetchData?: (url: string) => Promise<{ html?: string }>;
  handleFileUpload?: handleFileUploadType;
  handleFileSelection?: handleFileSelectionType;
  exposeButtons?: string[];
  disableDownload?: boolean;
  getAudioUrl?: (src: { id: string }) => string;
}

export interface AudioPluginViewerConfig extends ViewerPluginConfig {
  [key: string]: any; // eslint-disable-line @typescript-eslint/no-explicit-any
}

export type handleFileSelectionType = (
  updateEntity: UpdateEntityFileSelectFunc<AudioComponentData | ImageComponentData>,
  removeEntity?: any, // eslint-disable-line @typescript-eslint/no-explicit-any
  fromSettings?: boolean,
  componentData?: ComponentData
) => void;

export type handleFileUploadType = (
  files: File,
  updateEntity: UpdateEntityFileUploadFunc<AudioComponentData>
) => void;
